module.exports = __webpack_public_path__ + "img/medal11.6d7c6e03.png";